import React, {useState, useEffect} from 'react';
import Table from 'react-bootstrap/Table';
import ShortLinkoln from './ShortLinkoln';
import { useStoreActions, useStoreState } from "easy-peasy";


export default function ShortLinkolns () {
  const short_linkolns = useStoreState(state => state.short_linkolns.short_linkolns);
  const domain = useStoreState(state => state.current_domain);
  const get_short_linkolns = useStoreActions(actions => actions.short_linkolns.getShortLinkolns);
  const saveShortLinkoln = useStoreActions(actions => actions.short_linkolns.saveShortLinkoln);
  const [short_linkoln, setShortLinkoln] = useState({"destination": ""});

  useEffect(() => {
      get_short_linkolns(domain.domain);
  }, [domain, get_short_linkolns]);

  const onFieldChange = (e) => {
      e.preventDefault();
      let new_short_linkoln = {...short_linkoln};
      new_short_linkoln[e.target.name] = e.target.value;
      setShortLinkoln(new_short_linkoln);
  };

  const clearForm = () => {
    setShortLinkoln({destination: ''})
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
    if (!short_linkoln.destination) {
      alert("You must enter a destination URL");
      return;
    }
    let new_short_linkoln = {...short_linkoln};
      saveShortLinkoln({domain: domain.domain, short_linkoln: new_short_linkoln});
    clearForm();
  };

  return (
    <div className="container px-0">
        <div className="row">
          <div className="col">
          <h2>Welcome to Short Linkoln!</h2>
          <p>The place where those gigantically boring links transform into tiny, compact URLs. <strong>Don't let your links drag you down!</strong></p>
          <p>Just paste your lengthy URL into the box below, hit the magic button, and watch it transform into a sleek, short link. </p>
          </div>
        </div>
        <div classname="row">
          <div classname="col-12">
                <form id="newShortLinkoln" onSubmit={onFormSubmit}>
                <div class="input-group mb-3 p-3 p-md-4 bg-secondary shadow border border-3 border-light rounded-5">
                  <input type="text" class="form-control" name="destination" placeholder="Destination URL" value={short_linkoln.destination} onChange={onFieldChange} />
                  <button className="btn btn-primary" type="submit">Create</button>
                </div>
              </form>
          </div>
        </div>
        <div className="row">
        <div className="col-12">
        <h3>Short Linkolns</h3>
        <Table striped bordered responsive>
          <thead>
            <tr>
                <th>Short Linkoln</th><th>Destination URL</th><th>Preview</th>
            </tr>
          </thead>
          <tbody>
          {short_linkolns.map(short_linkoln => (
            <ShortLinkoln
              short_linkoln={short_linkoln}
              key={short_linkoln.short_linkoln_id}
            />
          ))}
          </tbody>
        </Table>
      </div>
      </div>
      <div className="row">
        <div className="col">
          <p><strong>Why Short Linkoln rules the stage:</strong></p>
          <ol>
            <li><strong>Short 'n' Sassy:</strong> We're the cutters of excess baggage. Say goodbye to those unnecessarily lengthy links. Short Linkoln gets straight to the point.</li>
            <li><strong>Clarity:</strong> Long, confusing web addresses are about as fashionable as a croc and sock combo. Short Linkoln makes your links clear, and cool– like a fresh new Birkenstock </li>
            <li><strong>No brainiac required:</strong> Using Short Linkoln is so easy it makes rocket science look complicated. Seriously, just paste your never-ending link, and bam! Your brand-new short link is ready to party. You don't need a PhD to rock this.</li>
            <li><strong>Stats that rock:</strong> We're not just about looks. Short Linkoln gives you the lowdown on who's clicking and when. </li>
            <li><strong>Link your way:</strong> With Short Linkoln, your links can finally embrace your brand's unique style. Say goodbye to generic, and hello to links that define your awesomeness!</li>
          </ol>
        </div>
      </div>
    </div>
  );
}
